import api from './axios';

export const getDashboard    = () => api.get('/api/superadmin/dashboard');
export const getOwners       = () => api.get('/api/superadmin/owners');
export const createOwner     = (data) => api.post('/api/superadmin/owners', data);
export const getOwnerById    = (id) => api.get(`/api/superadmin/owners/${id}`);
export const toggleOwner     = (id, data) => api.put(`/api/superadmin/owners/${id}/status`, data);
export const deleteOwner     = (id) => api.delete(`/api/superadmin/owners/${id}`);
export const getGroups       = () => api.get('/api/superadmin/groups');
export const getGroupById    = (id) => api.get(`/api/superadmin/groups/${id}`);
export const getMembers      = () => api.get('/api/superadmin/members');
export const getSystemStats  = () => api.get('/api/superadmin/stats');
export const getAdmins       = () => api.get('/api/superadmin/admins');
export const createAdmin     = (data) => api.post('/api/superadmin/admins', data);
export const updateAdmin     = (id, data) => api.put(`/api/superadmin/admins/${id}`, data);
export const deleteAdmin     = (id) => api.delete(`/api/superadmin/admins/${id}`);
